// Copyright (C) 2022 by Posit Software, PBC.

export const VISIBILITY_PUBLIC = 'public';
export const VISIBILITY_PRIVATE = 'private';
export const VISIBILITY_ADHOC = 'ad-hoc';
